import styled from "styled-components";
import { Empty } from "antd";

export const ActivityHeaderAction = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

export const NoteHint = styled.div`
  margin-bottom: 10px;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.5;
`;

export const LogList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LogItem = styled.div`
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr);
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }
`;

export const LogDot = styled.span`
  width: 10px;
  height: 10px;
  margin-top: 6px;
  border-radius: 50%;
  background: ${({ $tone }) => ($tone === "terminal" ? "#9ca3af" : "#2563eb")};
`;

export const LogMeta = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
`;

export const LogAction = styled.span`
  color: #111827;
  font-size: 14px;
  font-weight: 600;
`;

export const LogTime = styled.span`
  color: #9ca3af;
  font-size: 12px;
`;

export const StatusTransition = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 6px 0;
`;

export const TransitionArrow = styled.span`
  color: #9ca3af;
  font-size: 11px;
`;

export const LogMessage = styled.div`
  color: #374151;
  font-size: 14px;
  line-height: 1.55;
  overflow-wrap: anywhere;
`;

// The actor's own words for a transition (today: why an award was rejected).
// Rendered as free text - line breaks preserved - and visually separated from
// the machine-generated message above it, which never contains user input.
export const LogReason = styled.div`
  margin-top: 6px;
  padding: 6px 10px;
  border-left: 3px solid #fca5a5;
  border-radius: 0 4px 4px 0;
  background: #fef2f2;
  color: #374151;
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

export const LogActor = styled.div`
  margin-top: 4px;
  color: #6b7280;
  font-size: 12px;
`;

export const EmptyLogs = styled(Empty)`
  margin: 24px 0 10px;
`;
